import { Card, Col, Divider, Typography, Row, Spin, Tabs } from 'antd';
import React from 'react';
import { CompanyStats } from '../../models/company-interface';
import { CustomerServiceQueries } from '../../queries/customer-service-queries';
import VMDetail from './components/VMDetail';
import { HasRight, Rights } from '../../utilites/auth';

export default function SkynetPage() {

  const vmListQuery = CustomerServiceQueries.useVMList();
  const transcriptVmListQuery = CustomerServiceQueries.useTranscriptVMList();
  const { Title } = Typography;

  return (
    <>
      {!HasRight([Rights.CSDev]) ? 
        (<span>You do not have access to view this page.</span>)
      : (
        <Spin spinning={vmListQuery.isLoading}>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Title level={3}>
                Skynet - VM Information
              </Title>
            </Col>
            <Col span={24}>
              <Tabs style={{marginLeft: 10}}>
                <Tabs.TabPane tab="Bot VMs" key="bot">
                  <Row gutter={[16, 16]}>
                    {vmListQuery.data?.map(vmRecord => {
                      return (
                        <Col span={24}>
                          <VMDetail
                            vmRecord={vmRecord}
                            pageIsLoading={vmListQuery.isLoading}
                          />
                        </Col>
                      )
                    })}
                  </Row>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Transcript VMs" key="transcript">
                  <Row gutter={[16, 16]}>
                    {transcriptVmListQuery.data?.map(vmRecord => {
                      return (
                        <Col span={24}>
                          <VMDetail
                            vmRecord={vmRecord}
                            pageIsLoading={vmListQuery.isLoading}
                            isTranscription={true}
                          />
                        </Col>
                      )
                    })}
                  </Row>
                </Tabs.TabPane>
              </Tabs>
            </Col>
          </Row>
        </Spin>
      )}
    </>
  );
}
